//Nachladen der Bibliotheken von Timeline:
SWR.Social.prototype._updateTimeline = function _updateTimeline() {
  var self = this;
  COMMON.Utils.getScriptOnce("//cdn.knightlab.com/libs/timeline3/latest/js/timeline.js", updateAll);

  function updateAll() {
    COMMON.Utils.addStylesheetOnce("//cdn.knightlab.com/libs/timeline3/latest/css/timeline.css");
    self.$content.find('div[id^="timeline-embed-"]').each(updateOne);
  }

  function updateOne(index, value) {
    if (isDivAlreadyDone(value))
      return;

    self.$preview.hide();
    self.$content.show();
    self.$footer.show();

    var id = value.getAttribute('id');
    var src = value.getAttribute("data-timelinesrc");
    var timelineConfig = JSON.parse(value.getAttribute("data-timelinecfg"));

    new TL.Timeline(id, src, timelineConfig);

    self.$element.attr({
      'aria-busy': 'false'
    });
    self.$element.removeClass('embed-loading').addClass('embed-loaded');
    self._processing = false;
    self._processed = true;
  }

  function isDivAlreadyDone(div) {
    var wasAlreadyDone = div.getAttribute('data-update-social-done');
    if (!wasAlreadyDone) {
      div.setAttribute('data-update-social-done', '1');
    }
    return wasAlreadyDone;
  }
};
